import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';

import Loading from '../../common/Loading';
import Error from '../../common/Error';
import KPITotalReelsListItem from './KPITotalReelsListItem';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function KPITotalReels(props) {
    //console.debug("RTS Break KPITotalReels");

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();
    const history = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [repoRows, setRepoRows] = useState([]);

    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Analytics/GetReelsOnHandKPI";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token}}
        )
        .then(response => {
            if (response.data) {
                setRepoRows(response.data);
                setIsLoading(false);
            }
        })
        .catch(error => {
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    },[apiRoot, userAuthToken.token]); 


    useEffect(() => {
        fetchData(sessionCustomer.customer);
    }, [sessionCustomer]); 


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return (
        <Container maxWidth="xs" sx={{border:1, borderRadius:2}}>
            <Box sx={{textAlign:"center"}}>
                <Typography variant="h6">Reels On Hand</Typography>
            </Box>
            {/* <Box sx={{textAlign:"center"}}>
                <Typography variant="h5">{repoRows.length}</Typography>
            </Box> */}
            <Box sx={{px:2, textAlign:"center"}}>
                <Table size="small">
                    <TableBody>
                        {repoRows.map((row, idx) => (<KPITotalReelsListItem key={idx} data={row} />))}
                    </TableBody>
                </Table>
            </Box>
        </Container>
    );
}
